import { useEffect, useState } from "react";
import useUserRoles from "./useUserRoles";

const useIsFieldMarketer = () => {
  const roles = useUserRoles();
  const [isFieldMarketer, setIsFieldMarketer] = useState(false);
  const [isFieldMarketerOrAdmin, setIsFieldMarketerOrAdmin] = useState(false);

  useEffect(() => {
    const hasAdmin = roles.includes("Admin");
    const hasFieldMarketer = roles.includes("FieldMarketer");

    setIsFieldMarketer(hasFieldMarketer);
    if (hasAdmin || hasFieldMarketer) {
      setIsFieldMarketerOrAdmin(true);
    }
  }, [roles]);

  return { isFieldMarketer, isFieldMarketerOrAdmin };
};

export default useIsFieldMarketer;
